<div class="neo-tri-state-toggle-button">
  <mat-button-toggle-group [disabled]="disabled" #group="matButtonToggleGroup" [value]="value"
    [ngClass]="{ small: small === true }">
    <mat-button-toggle class="active-btn" [ngClass]="{ disabled: disabled }" [value]="triStateToggleTrue"
      (change)="valueChanged(group.value)">
      {{ activeLabel }}
    </mat-button-toggle>
    <mat-button-toggle [value]="triStateToggleNA" class="null-btn" [ngClass]="{ disabled: disabled }"
      (change)="valueChanged(group.value)">
      <span class="material-icons-round center-btn-icon">
        fiber_manual_record
      </span>
    </mat-button-toggle>
    <mat-button-toggle class="inactive-btn" [ngClass]="{ disabled: disabled }" [value]="triStateToggleFalse"
      (change)="valueChanged(group.value)">
      {{ inactiveLabel }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
